"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ricadi": {
    "e42ec366": [{
      "hkey": "5edb21fd",
      "slug": "ricadi",
      "name": "Ricadi",
      "primary": true,
      "skipSearch": false
    }],
    "barbalaconi": [{
      "hkey": "5edb21fd",
      "slug": "ricadi",
      "name": "Ricadi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "822eed76": [{
      "hkey": "3280f223",
      "slug": "brivadi-san-nicolo",
      "name": "Brivadi-San Nicolò",
      "primary": true,
      "skipSearch": false
    }],
    "brivadi": [{
      "hkey": "3280f223",
      "slug": "brivadi-san-nicolo",
      "name": "Brivadi-San Nicolò",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ricadi"
    }],
    "3531269e": [{
      "hkey": "4f071db0",
      "slug": "ciaramiti",
      "name": "Ciaramiti",
      "primary": true,
      "skipSearch": false
    }],
    "ciaramit": [{
      "hkey": "4f071db0",
      "slug": "ciaramiti",
      "name": "Ciaramiti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ec466a31": [{
      "hkey": "a4efa628",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "ricadi": [{
      "hkey": "a4efa628",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8f0feb14": [{
      "hkey": "3280f223",
      "slug": "brivadi-san-nicolo",
      "name": "Brivadi-San Nicolò",
      "primary": true,
      "skipSearch": false
    }],
    "san-nicolo": [{
      "hkey": "3280f223",
      "slug": "brivadi-san-nicolo",
      "name": "Brivadi-San Nicolò",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;